/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { Pausable, PausableInterface } from '../../FiatTokenV1.sol/Pausable';

const _abi = [
  {
    constant: false,
    inputs: [],
    name: 'unpause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newPauser',
        type: 'address',
      },
    ],
    name: 'updatePauser',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'paused',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'pause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'owner',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'pauser',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    anonymous: false,
    inputs: [],
    name: 'Pause',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [],
    name: 'Unpause',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newAddress',
        type: 'address',
      },
    ],
    name: 'PauserChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
];

const _bytecode =
  '0x60806040526001805460a060020a60ff021916905561002633640100000000610064810204565b60008054604051600160a060020a0390911691907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3610086565b60008054600160a060020a031916600160a060020a0392909216919091179055565b610839806100956000396000f3006080604052600436106100825763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416633f4ba83a8114610087578063554bab3c1461009e5780635c975abb146100cc5780638456cb59146100f55780638da5cb5b1461010a5780639fd0506d14610148578063f2fde38b1461015d575b600080fd5b34801561009357600080fd5b5061009c61018b565b005b3480156100aa57600080fd5b5061009c73ffffffffffffffffffffffffffffffffffffffff60043516610264565b3480156100d857600080fd5b506100e1610472565b604080519115158252519081900360200190f35b34801561010157600080fd5b5061009c610493565b34801561011657600080fd5b5061011f610583565b6040805173ffffffffffffffffffffffffffffffffffffffff9092168252519081900360200190f35b34801561015457600080fd5b5061011f61059f565b34801561016957600080fd5b5061009c73ffffffffffffffffffffffffffffffffffffffff600435166105bb565b60015473ffffffffffffffffffffffffffffffffffffffff16331461021157604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600b60248201527f706175736572206f6e6c79000000000000000000000000000000000000000000604482015290519081900360640190fd5b600180547fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff1690556040517f7805862f689e2f13df9f062ff482ad3ad112aca9e0847911ed832e158c525b3390600090a1565b61026c610583565b73ffffffffffffffffffffffffffffffffffffffff1633146102ef57604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601460248201527f6f6e6c794f776e65723a206e6f74206f776e6572000000000000000000000000604482015290519081900360640190fd5b73ffffffffffffffffffffffffffffffffffffffff8116151561037357604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601960248201527f7570646174655061757365723a2030783020696e76616c696400000000000000604482015290519081900360640190fd5b60015473ffffffffffffffffffffffffffffffffffffffff828116911614156103fd57604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601a60248201527f7570646174655061757365723a2073616d652061646472657373000000000000604482015290519081900360640190fd5b600180547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff83811691909117918290556040519116907fb80482a293ca2e013eda8683c9bd7fc8347cfdaeea5ede58cba46df502c2a60490600090a250565b60015474010000000000000000000000000000000000000000900460ff1681565b60015473ffffffffffffffffffffffffffffffffffffffff16331461051957604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600b60248201527f706175736572206f6e6c79000000000000000000000000000000000000000000604482015290519081900360640190fd5b600180547fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff16740100000000000000000000000000000000000000001790556040517f6985a02210a168e66602d3235cb6db0e70f92b3ba4d376a33c0f3d9434bff62590600090a1565b60005473ffffffffffffffffffffffffffffffffffffffff1690565b60015473ffffffffffffffffffffffffffffffffffffffff1681565b6105c3610583565b73ffffffffffffffffffffffffffffffffffffffff16331461064657604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601460248201527f6f6e6c794f776e65723a206e6f74206f776e6572000000000000000000000000604482015290519081900360640190fd5b73ffffffffffffffffffffffffffffffffffffffff811615156106ca57604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601e60248201527f7472616e736665724f776e6572736869703a2030783020696e76616c69640000604482015290519081900360640190fd5b6106d2610583565b73ffffffffffffffffffffffffffffffffffffffff8281169116141561075957604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f7472616e736665724f776e6572736869703a2073616d65206164647265737300604482015290519081900360640190fd5b8073ffffffffffffffffffffffffffffffffffffffff16610778610583565b73ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a36107c3816107c6565b50565b600080547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff929092169190911790555600a165627a7a72305820c12dfa982849b86eed5f20ea2721caacd4f67a5bea0471719794b3f48fbfec3c0029';

type PausableConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: PausableConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class Pausable__factory extends ContractFactory {
  constructor(...args: PausableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'Pausable';
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<Pausable> {
    return super.deploy(overrides || {}) as Promise<Pausable>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Pausable {
    return super.attach(address) as Pausable;
  }
  override connect(signer: Signer): Pausable__factory {
    return super.connect(signer) as Pausable__factory;
  }
  static readonly contractName: 'Pausable';

  public readonly contractName: 'Pausable';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PausableInterface {
    return new utils.Interface(_abi) as PausableInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Pausable {
    return new Contract(address, _abi, signerOrProvider) as Pausable;
  }
}
